const getNormalizedThreadId = (threadId) => {
  const normalizedThreadId = String(threadId || '').trim();

  return normalizedThreadId || null;
};

export default getNormalizedThreadId;
